import React from 'react';

import { useTheme } from '@mui/material/styles';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import clsx from 'clsx';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import useStyles from './styles';

interface IExpandActionButtonProps extends IBaseActionButtonProps {
  expanded: boolean;
}

const ExpandActionButton = (props: IExpandActionButtonProps) => {
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { expanded } = props;

  return (
    <BaseActionButton {...props}>
      <ExpandMoreIcon
        className={clsx(classes.icon, expanded && classes.expanded)}
      />
    </BaseActionButton>
  );
};

export default ExpandActionButton;
